import { useEffect, useState } from "react";
import { AppData } from "./app-data";
import { Event, ActivityRaw, EventType } from "./event";

export let appData: AppData;
let fetching = false;
let loading = false;

export const useData = () => {
  const [fetchingState, setFetchingState] = useState(fetching);
  const [data, setData] = useState(appData);
  const [activities, setActivities] = useState<any>({});
  const [loadingState, setLoading] = useState(false);

  const mapEntry = (entry: ActivityRaw, eventType: EventType) => ({
    ...entry,
    type: eventType,
    recurring: entry.recurring === "TRUE",
    day: entry.day ? parseInt(entry.day) : undefined,
    capacity: parseInt(entry.capacity),
    startsAt: new Date(entry.startsAt),
    endsAt: new Date(entry.endsAt),
    startTime: entry.startsAt,
    endTime: entry.endsAt,
    rsvp: entry.rsvp ? entry.rsvp.split(",") : [],
    payment: entry.payment,
    payment2: entry.payment2,
    payment3: entry.payment3,
    payment4: entry.payment4,
  });

  const mapNewEntry = (entry: ActivityRaw) => {
    const mappedEntry = {
      ...entry,
      tags: entry.tags ? entry.tags.split(",") : [],
      recurring: entry.recurring,
      day: entry.day,
      capacity: entry.capacity,
      startDate: entry.startDate ? new Date(entry.startDate) : undefined,
      endDate: entry.endDate ? new Date(entry.endDate) : undefined,
      startTime: entry.startTime,
      endTime: entry.endTime,
      rsvp: entry.rsvp ? entry.rsvp.split(",") : [],
      payment: entry.payment,
      showFoodOption: entry.showFoodOption,
      showExtendedHoursOption: entry.showExtendedHoursOption,
      noRegistration: entry.noRegistration,
      comingSoon: entry.comingSoon,
    };
    return mappedEntry;
  };

  const fetchContent = async () => {
    if (!fetching) {
      fetching = true;
      setFetchingState(fetching);

      // await fetch("https://us-central1-my-ci-crm.cloudfunctions.net/getInfo")
      //   .then((response) => response.json())
      //   .then((data) => {
      //     appData = data;
      //     const mappedEvents = data.events.map((entry: ActivityRaw) =>
      //       mapEntry(entry, EventType.Event)
      //     );
      //     const mappedSchedule = data.schedule.map((entry: ActivityRaw) =>
      //       mapEntry(entry, EventType.Schedule)
      //     );
      //     const mappedCamps = data.camps
      //       .map((entry: ActivityRaw) => mapEntry(entry, EventType.Camp))
      //       .filter((entry: Event) => {
      //         const now = new Date();
      //         const campDate = new Date(entry.endsAt);
      //         return campDate > now;
      //       });

      //     setData({
      //       events: mappedEvents,
      //       schedule: mappedSchedule,
      //       camps: mappedCamps,
      //       all: [...mappedEvents, ...mappedSchedule, ...mappedCamps],
      //     });
      //   })
      //   .finally(() => {
      //     fetching = false;
      //     setFetchingState(fetching);
      //   });

      loading = true;
      setLoading(loading);
      await fetch(
        "https://us-central1-my-ci-crm.cloudfunctions.net/getActivities"
      )
        .then((response) => response.json())
        .then((data) => {
          const newActivities: any = { all: {} };
          data.forEach((activity: ActivityRaw) => {
            const mappedEntry = mapNewEntry(activity);
            newActivities.all[mappedEntry.id] = mappedEntry;

            mappedEntry.tags.forEach((tag) => {
              if (!newActivities[tag]) {
                newActivities[tag] = [];
              }

              if (mappedEntry.endsAt) {
                const now = new Date();
                const entryDate = new Date(mappedEntry.endsAt);
                if (entryDate >= now) {
                  newActivities[tag].push(mappedEntry);
                }
              } else {
                newActivities[tag].push(mappedEntry);
              }
            });
          });

          setActivities(newActivities);
        })
        .finally(() => {
          loading = false;
          setLoading(loading);
        });
    }
  };

  useEffect(() => {
    if (!appData) {
      fetchContent();
    }
  }, []);

  return {
    fetching: fetchingState,
    loading: loadingState,
    events: data?.events,
    schedule: data?.schedule,
    camps: data?.camps,
    all: data?.all,
    activities,
  };
};
